var module = angular.module('meternet.dashboard.controllers.termoGaugeWidget', []);

module.config(function(dashboardProvider, contextPath, messages) {
    var widget = {
        templateUrl: 'dashboard/termo-gauge-widget.html',
        title : messages['dashboard.widgets.termoGauge.title'],
        description : messages['dashboard.widgets.termoGauge.desc'],
        controller : 'gaugeWidgetCtrl',
        screenshot: true,
        config : {
            type : "termo-gauge",
            series : [ {
                paramId : null,
                average : 1,
                derivative : 0,
                unit : "",
                majorTicks : 5,
                minorTicks : 3,
                max : 100,
                min : 0,
                precision : 2,
                scale : 0,
                zones : [ {
                    "color" : "#5cb85c",
                    from : 0,
                    to : 50
                }, {
                    "color" : "#f0ad4e",
                    from : 50,
                    to : 75
                }, {
                    "color" : "#d9534f",
                    from : 75,
                    to : 100
                } ]
            } ]
        },
        edit : {
            controller : 'gaugeWidgetEditCtrl',
            templateUrl: 'dashboard/gauge-widget-edit.html',
            resolve : {
                maxSeries : [ 'licenseService', function(licenseService) {
                    var license = licenseService.getLicense();
                    return license.properties.MAX_SERIES || 5;
                } ]
            }
        }
    };
    dashboardProvider.widget('termo-gauge', widget);
});